import type {
  ConstructionSiteDto,
  ConstructionSiteIntakeRequestDto,
  ConstructionSiteUpdateRequest,
} from "../dto/ConstructionSiteDto";
import type {
  ConstructionSite,
  CreateConstructionSiteIntakeCommand,
  UpdateConstructionSiteCommand,
} from "@domain/model/ConstructionSite";
import {
  asConstructionSiteId,
  asClientId,
  asAddressId,
} from "@domain/model/Ids";
import { asDate, iso } from "@domain/model/Time";
import { addressRequestFromCommand } from "./JobMapper";

export const constructionSiteFromDto = (
  d: ConstructionSiteDto,
): ConstructionSite => ({
  id: asConstructionSiteId(d.id),
  clientId: asClientId(d.clientId),
  addressId: d.addressId ? asAddressId(d.addressId) : null,
  label: d.label,
  version: d.version,
  createdAt: asDate(d.createdAt),
  updatedAt: asDate(d.updatedAt),
  deletedAt: d.deletedAt ? asDate(d.deletedAt) : null,
});

export const constructionSiteToDto = (
  c: ConstructionSite,
): ConstructionSiteDto => ({
  id: c.id,
  clientId: c.clientId,
  addressId: c.addressId,
  label: c.label,
  version: c.version,
  createdAt: iso(c.createdAt),
  updatedAt: iso(c.updatedAt),
  deletedAt: c.deletedAt ? iso(c.deletedAt) : null,
});

export const updateConstructionSiteRequestFromCommand = (
  cmd: UpdateConstructionSiteCommand,
): ConstructionSiteUpdateRequest => ({
  label: cmd.label ?? null,
  addressId: cmd.addressId ? String(cmd.addressId) : null,
  clientId: cmd.clientId ? String(cmd.clientId) : null,
});

export const constructionSiteIntakeRequestFromCommand = (
  cmd: CreateConstructionSiteIntakeCommand,
): ConstructionSiteIntakeRequestDto => ({
  client:
    cmd.client.kind === "existing"
      ? {
          kind: "existing",
          clientId: String(cmd.client.clientId),
        }
      : {
          kind: "new",
          name: cmd.client.name,
          contactName: cmd.client.contactName ?? null,
          phone: cmd.client.phone ?? null,
          email: cmd.client.email ?? null,
          address: addressRequestFromCommand(cmd.client.address),
        },

  constructionSite: {
    label: cmd.constructionSite.label ?? null,
    address:
      cmd.constructionSite.address.kind === "existing_address"
        ? {
            kind: "existing_address",
            addressId: String(cmd.constructionSite.address.addressId),
          }
        : cmd.constructionSite.address.kind === "client_address"
          ? {
              kind: "client_address",
            }
          : {
              kind: "new_address",
              address: addressRequestFromCommand(
                cmd.constructionSite.address.address,
              ),
            },
  },
});
